'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');

const stringOrUndefined = x => typeof x === 'string' ? x : undefined;
const lowercaseStringOrUndefined = x => typeof x === 'string' ? x.toLowerCase() : undefined;
const commaDelimitedStringToArray = x => typeof x === 'string' && x.length ? x.split(',') : [];
var parsePageParams = async (params, client) => {
  const {
    retailerMoniker,
    versionName,
    localeLanguage,
    localeCountry,
    type,
    category,
    carrier,
    trackingNumbers,
    orderNumbers,
    destinationZip,
    originZip,
    originCountry,
    destinationCountry,
    service,
    orderDate,
    shipDate,
    retailerDcId,
    productCategory,
    promiseDate,
    itemIds,
    itemNumber,
    phone,
    email,
    mainShipmentId,
    cache,
    experienceHost,
    token
  } = params;
  const {
    data: {
      globalSettings: {
        defaultCountry = 'en',
        defaultLanguage = 'US'
      } = {}
    } = {}
  } = await client.query({
    query: nthHookGlobalSettings.globalSettingsQuery(`
      defaultLanguage
      defaultCountry
    `),
    variables: {
      product: 'global',
      retailerMoniker,
      localeLanguage,
      localeCountry
    }
  });
  let language = stringOrUndefined(localeLanguage);
  let country = stringOrUndefined(localeCountry);
  // If only localeLanguage is provided, it's considered valid and
  // no need to set localeCountry
  if (!language) {
    language = stringOrUndefined(defaultLanguage);
    if (!country) {
      country = stringOrUndefined(defaultCountry);
    }
  }
  return {
    product: nthHookContextPage.Product.narvarjs,
    experienceHost,
    retailerMoniker: stringOrUndefined(retailerMoniker) || '',
    versionName: stringOrUndefined(versionName) || '',
    localeLanguage: language,
    localeCountry: country,
    // NOTE: Because this is an enumerable value, it must be set to
    // `undefined` if it is an empty string.
    type: stringOrUndefined(type) || undefined,
    // In case there is a tracking_numbers or order_number from the decodeParamsQuery
    // response, transform the comma delimited strings to arrays
    trackingNumbers: Array.isArray(trackingNumbers) ? trackingNumbers : commaDelimitedStringToArray(trackingNumbers),
    orderNumbers: Array.isArray(orderNumbers) ? orderNumbers : commaDelimitedStringToArray(orderNumbers),
    category: stringOrUndefined(category),
    carrier: lowercaseStringOrUndefined(carrier),
    destinationZip: stringOrUndefined(destinationZip),
    originZip: stringOrUndefined(originZip),
    originCountry: stringOrUndefined(originCountry),
    destinationCountry: stringOrUndefined(destinationCountry),
    service: stringOrUndefined(service),
    orderDate: stringOrUndefined(orderDate),
    shipDate: stringOrUndefined(shipDate),
    retailerDcId: stringOrUndefined(retailerDcId),
    productCategory: stringOrUndefined(productCategory),
    promiseDate: stringOrUndefined(promiseDate),
    itemIds: commaDelimitedStringToArray(itemIds),
    itemNumber: stringOrUndefined(itemNumber),
    email: stringOrUndefined(email),
    phone: stringOrUndefined(phone),
    mainShipmentId: stringOrUndefined(mainShipmentId),
    cache,
    token: stringOrUndefined(token)
  };
};

exports["default"] = parsePageParams;
